import { Link } from 'react-router-dom';

import { useUi } from '../i18n/ui-context';

export function NotFoundPage() {
  const { t } = useUi();

  return (
    <main className="notfound">
      <p className="notfound__code" dir="ltr">
        404
      </p>
      <h1>{t('notFound.title')}</h1>
      <p className="muted">{t('notFound.body')}</p>
      <Link className="button button--primary" to="/">
        {t('notFound.back')}
      </Link>
    </main>
  );
}
